
import { customElement, property } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

import style from './usos-progress.scss';

/**
 * Simple styled progress bar. Note that
 */
@customElement('usos-progress')
export class UsosProgress extends LitElement implements HTMLProgressElement {
    static override styles = style;

    @property({reflect: true, type: Number})
    max = 1;

    @property({reflect: true, type: Number})
    value = 0;

    @property({reflect: true})
    label = '';

    get position(): number {
        return this.value / this.max;
    }

    get labels(): NodeListOf<HTMLLabelElement> {
        return new NodeList() as NodeListOf<HTMLLabelElement>;
    }

    override render() {
        const backgroundStyle = styleMap({ background: `linear-gradient(to right, var(--primary) ${this.position * 100}%, transparent ${this.position * 100}%)` });
        return html`
            <div id="outer" role="progressbar" aria-label=${this.label} aria-valuemax=${this.max} aria-valuenow=${this.value}>
                <div id="inner" style=${backgroundStyle}></div>
            </div>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
      "usos-progress": UsosProgress,
    }
}
